module.exports = __webpack_public_path__ + "img/0.93b9ae0c.png";